import { useState } from 'react';
import clsx from 'clsx';
import { Transition } from '@headlessui/react';
import useTimeout from '@/hooks/useTimeout';
import Image from '@/components/Image/RemoteImage';
import Tooltip from '@/components/Tooltip';

function ParnetLogoGridCell({
  colStart,
  rowStart,
  children,
}) {
  return (
    <div className={clsx('flex items-center justify-center relative', colStart, rowStart)}>
      {children}
    </div>
  );
}

export function PartnerLogo({
  src,
  brandName,
  transitionDelay,
  animation,
}) {
  return (
    <Transition.Child
      enter={clsx('transition transform ease-linear duration-700', transitionDelay)}
      enterFrom="opacity-0 scale-50"
      enterTo="opacity-100 scale-100"
      leave={clsx('transition transform ease-linear duration-700', transitionDelay)}
      leaveFrom="opacity-100 scale-100"
      leaveTo="opacity-0 scale-50"
    >
      <Tooltip tooltip={brandName}>
        <button className={clsx('cursor-pointer block w-20 h-20 focus:outline-none rounded-full shadow-xl', animation)} type="button">
          <Image
            className="rounded-full"
            src={src}
            width={180}
            height={180}
            alt={brandName}
          />
        </button>
      </Tooltip>
    </Transition.Child>
  );
}

export default function PartnersLogosAnimation() {
  const [show, setShow] = useState(false);

  useTimeout(() => setShow(true), 0);

  return (
    <div className="absolute z-20 inset-0 grid grid-cols-12 grid-rows-12 lg:my-10">
      <Transition show={show} className="col-span-12 grid grid-cols-6 grid-rows-6 gap-2 p-4">
        <ParnetLogoGridCell colStart="col-start-2" rowStart="row-start-1">
          <PartnerLogo src="v1612275133/socios/klever_lchrdl.png" brandName="Klever Team" transitionDelay="delay-100" animation="animate-float-random-1" />
        </ParnetLogoGridCell>
        <ParnetLogoGridCell colStart="col-start-3" rowStart="row-start-2">
          <PartnerLogo src="v1612275132/socios/certificate-en-scrum_qru8vy.png" brandName="Certifícate en Scrum" transitionDelay="delay-100" animation="animate-float-random-2" />
        </ParnetLogoGridCell>
        <ParnetLogoGridCell colStart="col-start-5" rowStart="row-start-1">
          <PartnerLogo src="v1612275132/socios/cobalto-consulting_s2ysou.png" brandName="Cobalto Consulting" transitionDelay="delay-150" animation="animate-float-random-3" />
        </ParnetLogoGridCell>
        <ParnetLogoGridCell colStart="col-start-4" rowStart="row-start-6">
          <PartnerLogo src="v1612275132/socios/digital-boost_idohzl.png" brandName="DigitalBoost" transitionDelay="delay-300" animation="animate-float-random-6" />
        </ParnetLogoGridCell>
        <ParnetLogoGridCell colStart="col-start-2" rowStart="row-start-5">
          <PartnerLogo src="v1612275133/socios/fm-consulting_uovthk.png" brandName="F&M Consulting" transitionDelay="delay-200" animation="animate-float-random-4" />
        </ParnetLogoGridCell>
        <ParnetLogoGridCell colStart="col-start-6" rowStart="row-start-6">
          <PartnerLogo src="v1612275133/socios/ge-360_ypai0g.png" brandName="Grupo Empresarial 360" transitionDelay="delay-200" animation="animate-float-random-5" />
        </ParnetLogoGridCell>
        <ParnetLogoGridCell colStart="col-start-6" rowStart="row-start-3">
          <PartnerLogo src="v1612275133/socios/neuronforest_ldarsa.png" brandName="Neuron Forest" transitionDelay="delay-300" animation="animate-float-random-7" />
        </ParnetLogoGridCell>
      </Transition>
    </div>
  );
}
